import company from '@/api/administration/company'
import companyPhoto from '@/api/administration/company-photo'
import { baseState, baseMutations } from '@/store/mixins'

export const state = {
  ...baseState
}

export const getters = {}

export const mutations = {
  ...baseMutations
}

export const actions = {
  fetch(context, attributes = {}) {
    const params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage,
        search: context.state.search
      },
      attributes
    )
    return company.get({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  },

  onSaveCompanyProfile(context, data) {
    return company.store(data)
  },

  onUpdateCompanyProfile(context, data) {
    return company.update(data)
  },

  onUploadCompanyLogo(context, data) {
    return companyPhoto.store(data)
  },

  destroyCompany(context, id) {
    return company.destroy(id)
  },

  getLogoFile(context, company_id) {
    return companyPhoto.get(company_id)
  }
}
